import React from 'react';

import clsx from 'clsx';

import { makeStyles } from '@gogame/components';

import ErrorMessage from './ErrorMessage';

const useStyles = makeStyles(() => ({
  compared: {
    '& > *:first-child fieldset': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: 'dashed',
      marginBottom: '-1px',
    },
    '& > *:not(:first-child):not(:last-child) fieldset': {
      borderRadius: 0,
      borderTopStyle: 'dashed',
      borderBottomStyle: 'dashed',
      marginBottom: '-1px',
    },
    '& > *:last-child fieldset': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: 'dashed',
    },
  },
}));

const LayoutFilterPrimary = ({ children, compared, error }) => {
  const classes = useStyles();

  return (
    <div>
      <div
        className={clsx({
          [classes.compared]:
            compared &&
            React.Children.toArray(children).filter((i) => i).length > 1,
        })}
      >
        {children}
      </div>
      {error ? <ErrorMessage>{error?.message}</ErrorMessage> : null}
    </div>
  );
};

export default LayoutFilterPrimary;
